/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneTag from 'base/components/standalone/Tag';

export const DynamicStandaloneTag = StandaloneTag;
export type DynamicStandaloneTagProps = PropsFromComponent<typeof StandaloneTag>;

export const DynamicStandaloneTagWith = (extras: DynamicStandaloneExtras): typeof StandaloneTag => {
    return function DynamicStandaloneTag(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Tag');
        return <StandaloneTag {...mergeProps({ options: { theme } }, props)} />;
    }
}